import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomerSupportMenu from "./menu/customer-supoort-menu";
import ActionDelete from "components/buttons/actionDelete";
import SaveButton from "components/buttons/save";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import { BlobServiceClient } from '@azure/storage-blob';
import Swal from 'sweetalert2'
import { azureConfig } from "helpers/azureConfig";
import SafeField from "helpers/SafeField";
import { UPLOADTEXT } from "constants/layout";
class helpfulDocuments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      helpCategories: [],
      documents: []
    }

  }
  async handleFileChange(event, setFieldValue, setFieldTouched) {
    const file = event.currentTarget.files[0];
    if (file) {
      const maxSize = 5 * 1024 * 1024;
      const allowedTypes = ['application/pdf', 'application/msword', 'image/jpeg', 'image/png', 'image/webp'];
      const allowedExtensions = ['.pdf', '.doc', '.jpg', '.jpeg', '.png', '.webp'];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
      if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
        Swal.fire({
          title: 'File type or extension not allowed',
          text: 'Please upload a PDF, DOC, JPG, or PNG file.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
        return;
      }
      if (file.size > maxSize) {
        Swal.fire({
          title: 'Size not allowed',
          text: 'Please Upload Maximum 5MB File',
          icon: 'warning',
          confirmButtonText: 'OK',
        });

      }
      this.setState({ btnloading: true });
      const sasToken = azureConfig.sasToken;
      const containerName = azureConfig.containerName;
      const storageAccountName = azureConfig.storageAccountName;
      const fileName = `${Date.now()}_${file.name}`;
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
      );
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlockBlobClient(fileName);

      try {
        await blobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type }
        });


        if (setFieldValue) {
          const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;

          setFieldValue("file", file);
          setFieldValue("helpfulDocumentUrl", fileUrl);
          setFieldTouched("file", true);
          this.setState({ fileUploaded: true });
        }
      } catch (error) {
        console.error('Error uploading file:', error);

      }
    }
  }
  fetchCategory() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      agentId: localStorage.getItem("userId"),
    };
    axios
      .get(`${API_URL}HelpCategory/allforagent`, { headers, params })
      .then((response) => {
        this.setState({ helpCategories: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  fetchDocumets() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      agentId: localStorage.getItem("userId"),
    };
    axios
      .get(`${API_URL}AgentHelpfulDocument/allAgent`, { headers, params })
      .then((response) => {
        this.setState({ documents: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  componentDidMount() {
    this.fetchCategory();
    this.fetchDocumets();
  }

  handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        agentId: parseInt(localStorage.getItem('userId')),
        helpfulDocumentTitle: values.helpfulDocumentTitle,
        helpfulDocumentCategory: values.helpfulDocumentCategory,
        helpfulDocumentUrl: values.helpfulDocumentUrl,
        isActive: true
      }
      toast.loading('Please wait...')
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const response = await axios.post(
        `${API_URL}AgentHelpfulDocument`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        toast.dismiss();
        toast.success('Saved successfully.')
        this.fetchDocumets();
        resetForm();
      } else {
        toast.dismiss();
        toast.warn(response.data.validationErrors[0] || 'some issue please try after some time')
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setSubmitting(false);
    }
  };
  handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won’t be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;

        axios
          .delete(`${API_URL}AgentHelpfulDocument/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(() => {
            Swal.fire("Deleted!", "Deleted successfully", "success");
            this.setState((prevState) => ({
              documents: prevState.documents.filter((s) => s.id !== id),
            }));
          })
          .catch(() => {
            Swal.fire("Error!", "Something went wrong.", "error");
          });
      }
    });
  };
  render() {
    const { helpCategories, documents } = this.state;
    return (
      <React.Fragment>
      <ToastContainer autoClose={2000} />
        <div className="page-content">
          <MetaTags>
            <title>Agent Profile | Realty Space</title>
          </MetaTags>
          <Container fluid>


            <Row className="mb20">
              <Col xl="6">
                <Breadcrumbs
                  title={this.props.t("Setting")}
                  breadcrumbItem={this.props.t("Customer Support")}
                />

              </Col>

            </Row>
            <Row>
              <Col xl="3">
                <SettingSidebar />s
              </Col>

              <Col xl="9">
                <CustomerSupportMenu />
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    documentStorageType: 0,
                    helpfulDocumentTitle: "",
                    helpfulDocumentCategory: "",
                    helpfulDocumentUrl: "",
                    file: null,
                    isActive: true,
                  }}
                  validationSchema={Yup.object().shape({
                    helpfulDocumentTitle: Yup.string()
                      .max(50, "Title must not exceed 50 characters")
                      .required("This is Required"),
                    helpfulDocumentCategory: Yup.string().required("This is Required"),
                    helpfulDocumentUrl: Yup.string().when("documentStorageType", {
                      is: 1,
                      then: Yup.string()
                        .url("Must be a valid URL")
                        .required("This is Required"),
                    }),
                    file: Yup.mixed().when("documentStorageType", {
                      is: 0,
                      then: Yup.mixed().required("This is Required"),
                    }),
                  })}
                  onSubmit={this.handleSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                    <Form className="needs-validation">
                      <Card>
                        <CardBody>
                          <div className="mt-0 card-title pheading">Add New</div>

                          <Row>
                            {/* Radio Buttons */}
                            <Col sm="12">
                              <div className="btn-group" role="group">
                                <SafeField
                                  type="radio"
                                  className="btn-check"
                                  name="documentStorageType"
                                  id="documentStorageType1"
                                  value="0"
                                  checked={values.documentStorageType === 0}
                                  onChange={() => setFieldValue("documentStorageType", 0)}
                                />
                                <label
                                  className="btn btn-outline-secondary"
                                  htmlFor="documentStorageType1"
                                >
                                  Upload File
                                </label>

                                <SafeField
                                  type="radio"
                                  className="btn-check"
                                  name="documentStorageType"
                                  id="documentStorageType2"
                                  value="1"
                                  checked={values.documentStorageType === 1}
                                  onChange={() => setFieldValue("documentStorageType", 1)}
                                />
                                <label
                                  className="btn btn-outline-secondary"
                                  htmlFor="documentStorageType2"
                                >
                                  Add Link
                                </label>
                              </div>
                            </Col>

                            {/* Title */}
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="helpfulDocumentTitle">
                                  {this.props.t("Title*")}
                                </Label>
                                <SafeField
                                  name="helpfulDocumentTitle"
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.helpfulDocumentTitle &&
                                      touched.helpfulDocumentTitle
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="documentTitle"
                                />
                                <ErrorMessage
                                  name="helpfulDocumentTitle"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>

                            {/* File Upload (when documentStorageType = 0) */}
                            {values.documentStorageType === 0 && (
                              <Col sm="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="file">File upload*</Label>
                                  <input
                                    id="file"
                                    name="file"
                                    type="file"
                                    className={
                                      "form-control" +
                                      (errors.file && touched.file ? " is-invalid" : "")
                                    }
                                    onChange={event => this.handleFileChange(event, setFieldValue, setFieldTouched)}
                                  />
                                  <small>{UPLOADTEXT.DFOR}</small>
                                  <ErrorMessage
                                    name="file"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                            )}

                            {/* URL Input (when documentStorageType = 1) */}
                            {values.documentStorageType === 1 && (
                              <Col sm="3">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="helpfulDocumentUrl">
                                    {this.props.t("Link")}
                                  </Label>
                                  <SafeField
                                    name="helpfulDocumentUrl"
                                    type="text"
                                    className={
                                      "form-control" +
                                      (errors.helpfulDocumentUrl &&
                                        touched.helpfulDocumentUrl
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="helpfulDocumentUrl"
                                  />
                                  <ErrorMessage
                                    name="helpfulDocumentUrl"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                            )}

                            {/* Category Dropdown */}
                            <Col sm="2">
                              <FormGroup className="mb-3">
                                <Label htmlFor="helpfulDocumentCategory">
                                  {this.props.t("Type *")}
                                </Label>
                                <SafeField
                                  as="select"
                                  name="helpfulDocumentCategory"
                                  className={
                                    "form-control" +
                                    (errors.helpfulDocumentCategory &&
                                      touched.helpfulDocumentCategory
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={handleChange}
                                >
                                  <option value="">Select</option>
                                  {helpCategories.map((ind, index) => (
                                    <option key={index} value={ind.id}>
                                      {ind.helpCategoryTitle}
                                    </option>
                                  ))}
                                </SafeField>
                                <ErrorMessage
                                  name="helpfulDocumentCategory"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>

                            {/* Submit Button */}
                            <Col sm="2">
                              <div className="clearfix" style={{ marginTop: "30px" }}>
                                <SaveButton iconClass="">Submit</SaveButton>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>

                      {/* History Table */}
                      <Card>
                        <CardBody>
                          <h5 className="card-title">History</h5>
                          <div className="table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Title</th>
                                  <th>Type</th>
                                  <th>View</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                  {documents.map((doc, index) => (
                                <tr key={index}>
                                  <td>{doc.helpfulDocumentTitle}</td>
                                  <td>{helpCategories.find(opt => opt.id == doc.helpfulDocumentCategory)?.helpCategoryTitle || ""}</td>
                                  <td>
                                    <a href={doc.helpfulDocumentUrl} target="_blank" rel="noreferrer"> View</a>
                                  </td>
                                  <td>
                                    <ActionDelete onClick={() => this.handleDelete(doc.id)} />
                                  </td>
                                </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </CardBody>
                      </Card>
                    </Form>
                  )}
                </Formik>





              </Col>

            </Row>

          </Container>
        </div>
      </React.Fragment>
    )
  }
}
helpfulDocuments.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,


}
const mapStateToProps = () => (
  {



  })
const mapDispatchToProps = dispatch => ({


});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(helpfulDocuments))
